import * as React from "react"
import {Box} from "@mui/material";

import RepricingAlertCardRowBasic from "./Basic";



export default function RepricingAlertCardRowShared({ emails }) {

	if (!emails?.length) return <></>

	const [value, ...restEmails] = emails

	return <RepricingAlertCardRowBasic
		label="Shared With"
		value={<Box component="span">
			{value} { !!restEmails.length && <Box component="span" color="primary.main">
				+{restEmails.length}
			</Box> }
		</Box>}
	/>
}